module.exports = __webpack_public_path__ + "static/media/folders.838ab542.png";